import Content from '../content-interface';
import ManagementCalculationRuleHistory from './management-calculation-rules-history.entity';

export default class ManagementCalculationHistory implements Content {
  rules: ManagementCalculationRuleHistory[];

  version: number;

  constructor(obj: any = {}) {
    this.rules = ManagementCalculationRuleHistory.ofList(obj.rules) || [];
    this.version = obj.version || 1;
  }

  public static of(obj: any = {}): ManagementCalculationHistory {
    return new ManagementCalculationHistory(obj);
  }

  public static ofList(obj: any[]): ManagementCalculationHistory[] {
    return obj.map(this.of);
  }
}
